import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old link to the page Overview replaced: every salon's results now live on `/agency`. */
export const Route = createFileRoute('/_auth/agency/salon-results')({
  beforeLoad: () => {
    throw redirect({ to: '/agency', replace: true });
  },
});
